const selectors = {
    cartCheckout: document.querySelector('#cart-checkoutbtn'),
    checkoutSticky: document.querySelector('.checkoutbtn-sticky')
};

class templateCartJS {
    constructor() {
        this.stickyCheckout();
        this.sortOnLoadIfPending();
    }

    // Sticky checkout container on oage scroll
    stickyCheckout(){
        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if(entry.isIntersecting){
                    selectors.checkoutSticky.classList.remove('active');
                } else {
                    selectors.checkoutSticky.classList.add('active');
                }
            })
        });
            
        observer.observe(selectors.cartCheckout);
    }

    sortOnLoadIfPending(){
        try {
            console.log('Cart page: Checking for pending cart sort...');
            const shouldSort = window.sessionStorage.getItem('pendingCartSort') === '1';
            console.log('Cart page: pendingCartSort value:', shouldSort);
            if (shouldSort && window.cartSorter) {
                console.log('Cart page: Triggering cart sort on load');
                window.sessionStorage.removeItem('pendingCartSort');
                window.cartSorter.queueCartSorting([]);
            } else {
                console.log('Cart page: No pending sort or cartSorter not available');
            }
        } catch (e) {
            console.error('Cart page: Error in sortOnLoadIfPending:', e);
        }
    }
}

typeof templateCartJS !== 'undefined' && new templateCartJS();
